module.exports = __webpack_public_path__ + "static/img/detailTitle-cjsdb.aa46fef.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/detailTitle-cjsdb.png
// module id = 8
// module chunks = 0